import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function SaveFilled(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M6.525 1.515C3.076 1.515.3 4.352.3 7.827c0 4.177 1.96 7.228 4.336 9.513 1.837 1.768 3.98 3.124 5.668 4.193.467.295.899.569 1.28.823a.75.75 0 00.832 0c.375-.25.799-.52 1.257-.81 1.691-1.073 3.845-2.44 5.691-4.22 2.375-2.288 4.336-5.339 4.336-9.499 0-3.475-2.776-6.312-6.225-6.312-2.37 0-4.423 1.34-5.475 3.307-1.052-1.967-3.104-3.307-5.475-3.307z"
  }));
}

export { SaveFilled };
//# sourceMappingURL=SaveFilled.js.map